import { useEffect, useState } from "react";
import { Layout } from "./components/Layout";
import { WalletProvider } from "./wallet";
import { Home } from "./pages/Home";
import { Inference } from "./pages/Inference";
import { Account } from "./pages/Account";
import { Operate } from "./pages/Operate";
import { Stake } from "./pages/Stake";
import { Govern } from "./pages/Govern";
import { Bridge } from "./pages/Bridge";
import { Docs } from "./pages/Docs";
import { Whitepaper } from "./pages/Whitepaper";
import { Api } from "./pages/Api";
import { Brains } from "./pages/Brains";

/** Minimal hash router — no dependency, static-host friendly (works from any subpath / IPFS). */
function useHashRoute(): string {
  const [route, setRoute] = useState(() => window.location.hash.replace(/^#/, "") || "/");
  useEffect(() => {
    const onHash = () => setRoute(window.location.hash.replace(/^#/, "") || "/");
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);
  return route;
}

function Page({ route }: { route: string }) {
  // Docs and the Brain explorer have deep-linkable subsections, so they match by prefix.
  if (route === "/docs" || route.startsWith("/docs/")) return <Docs route={route} />;
  if (route === "/brains" || route.startsWith("/brains/")) return <Brains route={route} />;
  switch (route) {
    case "/inference":
      return <Inference />;
    case "/account":
      return <Account />;
    case "/operate":
      return <Operate />;
    case "/stake":
      return <Stake />;
    case "/govern":
      return <Govern />;
    case "/bridge":
      return <Bridge />;
    case "/whitepaper":
      return <Whitepaper />;
    case "/api":
      return <Api />;
    default:
      return <Home />;
  }
}

export function App() {
  const route = useHashRoute();
  return (
    <WalletProvider>
      <Layout route={route}>
        <Page route={route} />
      </Layout>
    </WalletProvider>
  );
}
